<div class="pageheader">
  <div class="page-title">
    <h1>Data groups</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
      <button class="btn btn-link" id="btnNew" *bizPermissionRequired="'Partner_Action_PartnerCreate'" (click)="newDataGroup()">Create new <ep-svg-icon icon="plus"></ep-svg-icon></button>
      <app-change-log-link *bizPermissionRequired="'DataGroup_Action_ShowLog'" [title]="'Data groups log'">
        <app-change-log-link-entity type="DataGroup"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
  <restricted-search-callout [visible]="isSearchResultRestricted"></restricted-search-callout>
  <restricted-search-callout [visible]="isSearchMaxResultReached" text="More partners might exist. Try filter your search."></restricted-search-callout>
</div>
<!-- Use [hidden] to keep the grid in the DOM - otherwise it's behavior will be strange regarding the datasource and refresh. -->
<dx-data-grid [hidden]="currentDataGroup"
  #gridDataGroups
  biz-grid
  [bizHideSelectedRowsComponent]="true"
  [selection]='{ mode: "single" }'
  [dataSource]='datagroups'
  [showIsLoading]="isLoading"
  (bizOnToolbarPreparing)="onToolbarPreparing($event)"
  (onRowDblClick)="onRowDblClick($event)"
  (onSelectionChanged)='selectionChangedDataGroup($event)'
  (onRowRemoving)="onRowRemoving($event)">
  <dxo-editing mode="row"
    [allowUpdating]="editAllowed"
    [allowAdding]="false"
    [allowDeleting]="deleteAllowed">
  </dxo-editing>

  <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

  <dxi-column dataField="DataGroupType" caption="Type" dataType="string"  width="110" [validationRules]="[{ type: 'required' }]"></dxi-column>
  <dxi-column dataField="Name" caption="Name" sortOrder="asc" dataType="string" [validationRules]="[{ type: 'required' }]"></dxi-column>
  <dxi-column caption="EntityCount" dataType="string" cellTemplate="formatEntityCount" width="140"></dxi-column>
  <dxi-column dataField="Description" caption="Description" dataType="string" [validationRules]="[{ type: 'required' }]"></dxi-column>

  <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
    <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(datagroups, 'CreatedBy'))"></dxo-header-filter>
  </dxi-column>
  <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
  <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
    <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(datagroups, 'UpdatedBy'))"></dxo-header-filter>
  </dxi-column>
  <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

  <dxi-column type="buttons">
    <dxi-button name="edit" [onClick]="editItem">
    </dxi-button>
    <dxi-button name="delete">
    </dxi-button>
    <dxi-button text="Show Log"
      template="logTemplate"
      [visible]="showLogAllowed">
    </dxi-button>
  </dxi-column>

  <ng-container *dxTemplate="let cell of 'logTemplate'">
    <app-change-log-link *bizPermissionRequired="'DataGroup_Action_ShowLog'" [title]="'Log for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
      <app-change-log-link-entity type="DataGroup" [id]="cell.data.Id"></app-change-log-link-entity>
    </app-change-log-link>
  </ng-container>

  <div *dxTemplate="let cell of 'formatEntityCount'">
    @if (cell.data.EntityCount) {
      <span>{{cell.data.EntityCount}} {{cell.data.DataGroupType}}s</span>
    }
  </div>
</dx-data-grid>

<!-- Below is the Edit mode -->

@if (currentDataGroup) {
  <div>
    @if (currentDataGroup.DataGroupType === 'Partner') {
      <div>
        <form #dataGroupForm="ngForm" name="dataGroupForm" (ngSubmit)="search()">
          <div class="row">
            <div class="col-sm-3 form-group">
              <label title="Name of the datagroup">Name</label>
              <input name="inputName" #inputName="ngModel" class="form-control" type="text" [(ngModel)]="currentDataGroup.Name" required />
              @if (inputName.errors && (inputName.dirty || inputName.touched || dataGroupForm.submitted)) {
                <div class="error">Please enter a name</div>
              }
            </div>
            <div class="col-sm-9 form-group">
              <label title="Describe the intent of the data group. E.g. Grant access to all Purchase document types, or grant access to all Vendors/Suppliers">Description</label>
              <input name="inputDescription" class="form-control" type="text" [(ngModel)]="currentDataGroup.Description" />
            </div>
          </div>
          <div class="row">
            <div class="col-sm-5">
              <h2>Available partners</h2>
              <div class="container container-search">
                <div class="row">
                  <div class="col-sm-8">
                    <div class="form-group">
                      <input id="partnerSearchfield" type="text" class="form-control" [(ngModel)]="searchSettings.searchString" [ngModelOptions]="{standalone: true}" placeholder="Search..." [readonly]="isSearching" autofocus />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <ep-tag-selector (selectedTagsChange)="selectedTagsChange($event)"></ep-tag-selector>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 justifyer">
                    <div class="justify-item">
                      <button id="btnPartnerSearch" type="button" type="submit" class="btn btn-primary" (click)="search()" [disabled]="isSearching">Search</button>
                      <button id="btnResetSearch" type="button" class="btn btn-link" (click)="clear()" [disabled]="isSearching">Reset search <ep-svg-icon icon="circle-cross"></ep-svg-icon></button>
                    </div>
                    <div class="justify-item">
                      <div class="controls-inline">
                        <label class="control control-checkbox">
                          <input id="chkExtendedSearch" type="checkbox" [(ngModel)]="searchSettings.extendedSearch" [ngModelOptions]="{standalone: true}" placeholder="Search..." [disabled]="isSearching" /><i></i>
                          Extended search
                        </label>
                        <label class="control control-checkbox">
                          <input id="chkOnlyProxyPartners" type="checkbox" [(ngModel)]="searchSettings.onlyProxyPartners" [ngModelOptions]="{standalone: true}" [disabled]="isSearching" /><i></i>
                          Only proxy partners
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <dx-data-grid #gridAvailablePartners
                biz-grid
                height="800"
                [bizSetScrolling]="false"
                [bizSetGroupPanel]="true"
                [bizSetPager]="true"
                [bizSetExport]="false"
                [bizSetStateStoring]="false"
                [bizSetColumnChooser]="false"
                [bizSetAllowColumnReordering]="false"
                [showResetButton]="false"
                [selection]='{ mode: "multiple" }'
                [dataSource]='availablePartners'
                (onSelectionChanged)='selectionChangedAvailablePartners($event)'>
                <!--<dxo-scrolling mode="virtual"></dxo-scrolling>-->
                <dxi-column dataField="PartnerName" caption="Name" dataType="string" width="30%"></dxi-column>
                <dxi-column dataField="MainIdentificationName" caption="Identification type" dataType="string" width="25%"></dxi-column>
                <dxi-column dataField="MainIdentificationValue" caption="Identification" dataType="string" width="25%"></dxi-column>
                <dxi-column dataField="PartnerTags" caption="Tags" dataType="string" width="20%"></dxi-column>
              </dx-data-grid>
            </div>
            <div class="col-sm-2" style="padding-top: 130px;">
              <button id="btnAddPartner" type="button" class="form-control" (click)="addSelectedPartners()"> >> </button>
              <br />
              <br />
              <button id="btnRemovePartner" type="button" class="form-control" (click)="removeSelectedPartners()"> << </button>
            </div>
            <div class="col-sm-5">
              <h2>Selected partners</h2>
              <dx-data-grid #gridSelectedPartners
                biz-grid
                height="800"
                [bizSetScrolling]="false"
                [bizSetGroupPanel]="true"
                [bizSetPager]="true"
                [bizSetExport]="false"
                [bizSetStateStoring]="false"
                [bizSetColumnChooser]="false"
                [bizSetAllowColumnReordering]="false"
                [showResetButton]="false"
                [selection]='{ mode: "multiple" }'
                [dataSource]='currentDataGroup.Partners'
                (onSelectionChanged)='selectionChangedSelectedPartners($event)'>
                <!--<dxo-scrolling mode="virtual"></dxo-scrolling>-->
                <dxi-column dataField="PartnerName" caption="Name" dataType="string" width="30%"></dxi-column>
                <dxi-column dataField="MainIdentificationName" caption="Identification type" dataType="string" width="25%"></dxi-column>
                <dxi-column dataField="MainIdentificationValue" caption="Identification" dataType="string" width="25%"></dxi-column>
                <dxi-column dataField="PartnerTags" caption="Tags" dataType="string" width="20%"></dxi-column>
              </dx-data-grid>
            </div>
          </div>
          <br /><br />
          <div class="btn-toolbar form-group">
            <div class="btn-group">
              <button id="btnSave" class="btn btn-primary btn-sm" (click)="save()">Save</button>
            </div>
            <div class="btn-group">
              <button id="btnCancel" class="btn btn-primary btn-sm" (click)="cancel()">Cancel</button>
            </div>
            <div class="btn-group">
              @if (!dataGroupForm.valid && dataGroupForm.submitted) {
                <div class="error">Please fill out all required fields</div>
              }
            </div>
          </div>
        </form>
      </div>
    }
    @if (currentDataGroup.DataGroupType === 'DocumentType') {
      <div>
        <form #dataGroupForm="ngForm" name="dataGroupForm">
          <div class="row">
            <div class="col-sm-3 form-group">
              <label title="Name of the datagroup">Name</label>
              <input name="inputName" #inputName="ngModel" class="form-control" type="text" [(ngModel)]="currentDataGroup.Name" required />
              @if (inputName.errors && (inputName.dirty || inputName.touched || dataGroupForm.submitted)) {
                <div class="error">Please enter a name</div>
              }
            </div>
            <div class="col-sm-9 form-group">
              <label title="Describe the intent of the data group. E.g. Grant access to all Purchase document types, or grant access to all Vendors/Suppliers">Description</label>
              <input name="inputDescription" class="form-control" type="text" [(ngModel)]="currentDataGroup.Description" />
            </div>
          </div>
          <div class="row">
            <div class="col-sm-5">
              <h2>Available document types</h2>
              <dx-data-grid #gridAvailableDistributionObjects
                biz-grid
                height="900"
                [bizSetScrolling]="false"
                [bizSetGroupPanel]="false"
                [bizSetPager]="false"
                [bizSetExport]="false"
                [bizSetStateStoring]="false"
                [bizSetColumnChooser]="false"
                [bizSetAllowColumnReordering]="false"
                [showResetButton]="false"
                [stateStorageKey]="stateStorageKey"
                [selection]='{ mode: "multiple" }'
                [dataSource]='availableDistributionObjects'
                (onSelectionChanged)='selectionChangedAvailableDistributionObjects($event)'>
                <dxo-scrolling mode="virtual"></dxo-scrolling>
                <dxi-column dataField="Name" caption="Name" dataType="string"></dxi-column>
              </dx-data-grid>
            </div>
            <div class="col-sm-2" style="padding-top: 130px;">
              <button id="btnAddDocumentTypes" type="button" class="form-control" (click)="addSelectedDistributionObjects()"> >> </button>
              <br />
              <br />
              <button id="btnRemoveDocumentTypes" type="button" class="form-control" (click)="removeSelectedDistributionObjects()"> << </button>
            </div>
            <div class="col-sm-5">
              <h2>Selected document types</h2>
              <dx-data-grid #gridSelectedDistributionObjects
                biz-grid
                height="900"
                [bizSetScrolling]="false"
                [bizSetGroupPanel]="false"
                [bizSetPager]="false"
                [bizSetExport]="false"
                [bizSetStateStoring]="false"
                [bizSetColumnChooser]="false"
                [bizSetAllowColumnReordering]="false"
                [showResetButton]="false"
                [stateStorageKey]="stateStorageKey"
                [selection]='{ mode: "multiple" }'
                [dataSource]='currentDataGroup.DistributionObjectConnections'
                (onSelectionChanged)='selectionChangedSelectedDistributionObjects($event)'>
                <dxo-scrolling mode="virtual"></dxo-scrolling>
                <dxo-editing mode="batch"
                  [allowUpdating]="true"
                  [allowAdding]="false"
                [allowDeleting]="false"></dxo-editing>
                <dxi-column dataField="DistributionObject.Name" [allowEditing]="false" caption="Name" dataType="string" width="75%"></dxi-column>
                <dxi-column dataField="AccessTrackingDocuments" caption="Access Tracking Documents" dataType="boolean" width="25%"></dxi-column>
              </dx-data-grid>
            </div>
          </div>
          <br /><br />
          <div class="btn-toolbar form-group">
            <div class="btn-group">
              <button id="btnSave" class="btn btn-primary btn-sm" (click)="save()">Save</button>
            </div>
            <div class="btn-group">
              <button id="btnCancel" class="btn btn-primary btn-sm" (click)="cancel()">Cancel</button>
            </div>
            <div class="btn-group">
              @if (!dataGroupForm.valid && dataGroupForm.submitted) {
                <div class="error">Please fill out all required fields</div>
              }
            </div>
          </div>
        </form>
      </div>
    }
    @if (currentDataGroup.DataGroupType === 'Undecided') {
      <div>
        <div class="row">
          <div class="col-sm-3 form-group">
            <label title="Name of the datagroup">Name</label>
            <input name="inputName" #inputName="ngModel" class="form-control" type="text" [(ngModel)]="currentDataGroup.Name" required />
            @if (inputName.errors && (inputName.dirty || inputName.touched )) {
              <div class="error">Please enter a name</div>
            }
          </div>
          <div class="col-sm-9 form-group">
            <label title="Describe the intent of the data group. E.g. Grant access to all Purchase document types, or grant access to all Vendors/Suppliers">Description</label>
            <input name="inputDescription" class="form-control" type="text" [(ngModel)]="currentDataGroup.Description" />
          </div>
        </div>
        <div>
          <h3>Choose either Partners or Document Types for this Data Group</h3>
          <div class="btn-toolbar form-group">
            <div class="btn-group">
              <button id="btnSetGroupForPartners" class="btn btn-primary btn-sm" (click)="setGroupForPartners()">Add Partners</button>
            </div>
            <div class="btn-group">
              <button id="btnSetGroupForDocumentTypes" class="btn btn-primary btn-sm" (click)="setGroupForDocumentTypes()">Add Document Types</button>
            </div>
          </div>
        </div>
        <br /><br />
        <br /><br />
        <div class="btn-group">
          <button id="btnCancel" class="btn btn-primary btn-sm" (click)="cancel()">Cancel</button>
        </div>
      </div>
    }
  </div>
}
